<template>
<!--  <LockScreen :browser="browser" :version="version" v-if="errorVersion"/>-->
  <div id="app" :queue-router-hook="pageName" class="app" :class="{'app_loading': loadingGui}">
    <router-view/>
    <Auth/>
  </div>
</template>

<style lang="stylus">
@import "~@/assets/stylus/common.styl"
</style>

<script>

import LoadingGuiManager from '@/app/mixins/loading-gui-manager'
import timer from '@/app/timer/timer'
// components
import Auth from '@/components/auth/Auth'
// import LockScreen from '@/components/lock-screen/LockScreen'
import { detect } from 'detect-browser'
import { browsers } from '@/app/const/settings'

export default {
  mixins: [LoadingGuiManager, timer],
  data () {
    return {
      browser: null,
      version: null
    }
  },
  computed: {
    pageName () {
      return this.$route.name
    },
    errorVersion () {
      if (this.browser === browsers.chrome) {
        return this.version < browsers.chromeMinSupportVersion
      }
      if (this.browser === browsers.firefox) {
        return this.version < browsers.firefoxMinSupportVersion
      } else {
        return true
      }
    }
  },
  components: {
    Auth
    // LockScreen
  },
  beforeMount () {
    const detectBrowser = detect()
    this.browser = detectBrowser.name
    this.version = detectBrowser.version.split('.')[0]
  }
}
</script>
